import React from 'react'
import PropTypes from 'prop-types'

// Components
import Button from 'ui/Button'
import Col from 'ui/Col'
import Row from 'ui/Row'
import Text from 'ui/Text'

export const TicketCommentTagResolved = ({ onCancel, onResolve }) => {
  return (
    <div style={{ padding: '20px 0' }}>
      <Text bold color="#000000">
        Tag as resolved
      </Text>
      <Text color="#000000" paddingBottom={10}>
        Please confirm if we have answered/helped you with this issue
      </Text>
      <Row multiline>
        <Col sm={6} md={5}>
          <Button block variant="outline-primary" onClick={onCancel}>
            Not yet, send new comment
          </Button>
        </Col>
        <Col sm={6} md={4}>
          <Button block onClick={onResolve}>
            Yes, tag as resolved
          </Button>
        </Col>
      </Row>
    </div>
  )
}

TicketCommentTagResolved.propTypes = {
  onCancel: PropTypes.func,
  onResolve: PropTypes.func,
}

TicketCommentTagResolved.defaultProps = {
  onCancel: () => {},
  onResolve: () => {},
}

export default TicketCommentTagResolved
